<template>
    <v-card class="mx-auto" max-width="800">
        <v-data-table 
         :headers="headers" 
         :items="departments"    
         :rows-per-page-items="[8,16,24,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
         no-data-text="Nahrajte aktuální data tlačítkem [STÁHNOUT Z POKLADNY]">
            <template v-slot:items="props">
                <td class="text-xs-left subheading">
                    {{ props.item.id }}
                </td>
                <td class="text-xs-left subheading">
                    <v-edit-dialog
                    :return-value.sync="props.item.name"
                    lazy
                    > {{ props.item.name  }}
                    <template v-slot:input>
                        <v-form @submit.prevent="onSubmit" v-model="valid">
                            <v-text-field
                                v-model="props.item.name"
                                :rules="rules"
                                label="Editace"
                                single-line
                                outline
                            ></v-text-field>
                        </v-form>
                    </template>
                    </v-edit-dialog>
                </td>
                <td class="text-xs-right">    
                    <v-select dense v-model="props.item.vat_value" :items="vatOptions" item-value="id" item-text="vat_rate" ></v-select>    
                </td>
            </template>
            <template v-slot:item.vat="{ item }">
                <v-select v-model="item.vat" :items="vatOptions" label="DPH" outlined></v-select>
            </template>
        </v-data-table>
        <v-card-actions>
            <v-layout align-center justify-start>
                <v-btn color="primary" @click="loadData" :disabled="!sdrv">{{ $t('stáhnout z pokladny') }}</v-btn>
            </v-layout>
            <v-layout align-center justify-end>
                <v-btn color="info"  @click="save" :disabled="!sdrv || !valid">{{ $t('nahrát do pokladny') }}</v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    /*eslint-disable */
    name: 'department-table',
    props:['ecr', 'sdrv'],
    data() {
        return {
            headers: [
                { text: 'ID', value: 'id', class:'subheading'},
                { text: 'Název prodejní skupiny', value: 'name', sortable: false, class:'subheading' },
                { text: 'DPH', value: 'vat', sortable: false, class:'subheading' },
            ],
            departments: [],
            vatOptions: [{ id: 0, vat_name: "12%", vat_rate: 12 }, {id: 1, vat_name: "21%", vat_rate: 21 }, { id: 2, vat_name: "0%", vat_rate: 0 }],
            rules: [(v)=> v.length <= 20 || 'Přílis dlouhý popis', v => !!v || 'Popis je vyžadován'],
            valid: true
        }
    },
    methods: {
        onSubmit(e){

        },
        async loadData() {
            try {
                this.$emit('loading', true)
                this.loading = true
                let response = await this.axios.get(`/api/ecr-vattable?ip=${this.ecr.ip_vpn}`)
                console.log(response)
                this.vatOptions = [{ id: 0, vat_name: 'bez DPH', vat_rate: 0 }, ...response.data]
                let dpt = await this.axios.get(`/api/ecr-departmenttable?ip=${this.ecr.ip_vpn}`)
                console.log(dpt)
                this.departments = dpt.data
            } catch (e) {
                console.log(e)
                this.$root.$gerror(e.response.data)
            } finally {
                this.loading = false
                this.$emit('loading', false)
            }
            
        },
        async save() {
            try {
                this.$emit('loading', true)
                this.loading = true
                await this.axios.put(`/api/ecr-departmenttable/?ip=${this.ecr.ip_vpn}`, this.departments)
            } catch (e) {
                console.log(e)
                this.$root.$gerror(e.response.data)
            } finally {
                this.loading = false
                this.$emit('loading', false)
            }

        }
       
    },
}
</script>

<style>
/* Add your custom styles here */
</style>
